import { Map } from 'immutable';

import config from '../config';

const NOT_SUPERVISOR_ROLES = [config.RESEARCH_INTERN, config.JUNIOR_ANALYST];

/**
 * Check if user name starts with entered value (case-insensitive).
 *
 * @param {Immutable.Map} user User.
 * @param {string} value Entered value.
 * @returns {boolean} True if user name matches.
 */
const isUserNameMatched = (user, value) =>
  user
    .get('userName', '')
    .toLowerCase()
    .startsWith(value.trim().toLowerCase());

/**
 * Map user to suggestion item.
 *
 * @param {Immutable.Map} user User.
 * @returns {Immutable.Map} Suggestion item.
 */
const toSuggestion = user => Map({ id: user.get('id'), name: user.get('userName') });

/**
 * Get module suggestions. A module can be any user.
 *
 * @param {Immutable.List} users List of users.
 * @param {string} value Entered value.
 * @returns {Immutable.List} Suggestion list.
 */
export const getModuleSuggestions = (users, value = '') =>
  users.filter(user => isUserNameMatched(user, value)).map(toSuggestion);

/**
 * Get supervisor suggestions. A supervisor can be all user roles except Research Intern and Junior Analyst.
 *
 * @param {Immutable.List} users List of users.
 * @param {string} value Entered value.
 * @returns {Immutable.List} Suggestion list.
 */
export const getSupervisorSuggestions = (users, value = '') =>
  users
    .filter(user => isUserNameMatched(user, value) && !NOT_SUPERVISOR_ROLES.includes(user.get('role')))
    .map(toSuggestion);
